// extracted by mini-css-extract-plugin
module.exports = {"input":"input_input__HPZtR","textarea":"input_textarea__1Xopk","disabled":"input_disabled__Erfav"};